import React from 'react';
import { VideoPanel } from './view/videoPanel';

export const renderRule = {
  match: (item, cmsOption) => item.itemTypeCode === 'VideoPanel', 
  itemElt: (item, cmsOption) => <VideoPanel item={item} cmsOption={cmsOption} />
}